// Realtime hints from realtime-delivery-gateway. An activity hint carries
// `activities: [{ activityId, eventName, customerId }]`; a notification hint carries none.

// Amplify delivers the published payload under `event`, sometimes still as a JSON string.
export function hintFromMessage(msg) {
  let payload = msg && typeof msg === "object" && "event" in msg ? msg.event : msg;
  if (typeof payload === "string") {
    try {
      payload = JSON.parse(payload);
    } catch {
      return null;
    }
  }
  return payload && typeof payload === "object" ? payload : null;
}

// Event names carried by a hint, or null when it carries none.
export function hintEventNames(hint) {
  const activities = hint?.activities;
  if (!Array.isArray(activities)) return null;
  return activities.map((a) => a?.eventName).filter((name) => typeof name === "string");
}

/**
 * Whether a hint concerns any of `eventNames` (case-insensitive).
 *
 * With no filter, or a hint that carries no event names, the answer is yes:
 * an unreadable hint still means something changed on the channel.
 */
export function hintMatches(msg, eventNames) {
  if (!eventNames) return true;
  const names = hintEventNames(hintFromMessage(msg));
  if (names === null) return true;
  const wanted = new Set(eventNames.map((name) => name.toLowerCase()));
  return names.some((name) => wanted.has(name.toLowerCase()));
}
